module.exports = __webpack_public_path__ + "img/set3.75386063.png";